import React, { useState, useEffect, useMemo } from "react";
import { tokens } from "../../public/tokens.js";
import { getResultStyle, getMarkColor, formatResult } from "./GradebookHelperUtils";
import { GetSubjectAssignments } from "../../services/QualificationService.js";
import SkeletonStudentHub from "../../loaders/SkeletonStudentHub.js";


const styles = {

    gradeBook: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "24px",
        alignSelf: "stretch",
        width: "100%",
    },

    overallResultsBox: {
        display: "flex",
        width: "100%",
        padding: "12px 0 12px 24px",
        borderRadius: tokens.globals["border-radius"],
        border: `1px solid ${tokens.colors.ui.border}`,
        background: tokens.colors.ui.background,
        boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.05)",
    },

    infoColumn: {
        display: "flex",
        padding: "3px 28px 3px 0",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "10px",
        flex: "1 0 0",
    },

    markResultColumn: {
        display: "flex"        
    },

    courseResult: {
        fontSize: tokens.typography.fontSize["base-16px"],
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "16.8px",
    },

    tableResultBox: {
        display: "flex",
        alignItems: "center",
        alignSelf: "stretch",
        flexDirection: "column",
        background: tokens.colors.ui.background,
        borderRadius: tokens.globals["border-radius"],
        border: `1px solid ${tokens.colors.ui.border}`,
        overflow: "hidden",
    },

    tableHeader: {
        display: "flex",
        width: "100%",
        height: "56px",
        borderBottom: `1px solid ${tokens.colors.ui.border}`,
        background: tokens.colors.ui.background,
        color: tokens.colors.neutral.grey["800"],
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.bold,
    },

    tableContent: {
        display: "flex",
        width: "100%",
        minHeight: "56px",
        alignItems: "stretch",
        borderBottom: `1px solid ${tokens.colors.ui.border}`,
        background: tokens.colors.ui.background,
    },

    assessmentCell: {
        display: "flex",
        minHeight: "50px",
        minWidth: "0px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        flex: "1 0 0",
        padding: "12px 0 12px 24px",
        borderRight: `1px solid ${tokens.colors.ui.border}`,
    },

    markResultCell: {
        display: "flex",
        padding: "0 12px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "90px",
        gap: "12px",
        borderRight: `1px solid ${tokens.colors.ui.border}`,
    },

    assessmentName: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        color: tokens.colors.brand.blue["500"],        
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "130%",
    },

    assessmentMark: {
        display: "flex",
        width: "59px",
        height: "30px",
        flexDirection: "column",
        justifyContent: "center",
        color: tokens.colors.neutral.grey["800"],
        textAlign: "center",
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.regular,
        lineHeight: "110%",
        letterSpacing: "0.07px",
    },

    metaData: {
        color: tokens.colors.text.secondary,
        fontSize: "12px",
        fontWeight: tokens.typography.fontWeights.regular,
    },

    failRow: {
        background: "rgba(196, 62, 81, 0.05)",
    },

    witheldText: {
    color: tokens.colors.brand["burnt-orange"]["600"],
    fontWeight: tokens.typography.fontWeights.semibold,
     textTransform: "uppercase",
},

    noRecords: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    assesmentType: {
        fontSize: tokens.typography.fontSize["md-12px"],
        fontWeight: tokens.typography.fontWeights.semibold,
        color: tokens.colors.neutral.grey["600"],
    },
}
const RobotResult = (gradeText ) => (
    gradeText === "Incomplete" ? (
        <div className="as-red">
            <p className="gradeRobot">
                <i className="gradeRobotIcon fas fa-circle"></i> Incomplete
            </p>
        </div>
    ) : gradeText === "Competent" ? (
        <div className="as-green">
            <p className="gradeRobot">
                <i className="gradeRobotIcon fas fa-circle"></i> Competent
            </p>
        </div>
    ) : (
        <div className="as-orange">
            <p className="gradeRobot">
                <i className="gradeRobotIcon fas fa-circle"></i> Not Yet Competent
            </p>
        </div>
    )
);

const SubjectGradebook = ({ sid, passStatus, gradeText, intakeLockStatus }) => {

    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);

    useEffect(() => {
        const load = async () => {
            if (!sid) return;

            setLoading(true);
            setLoadingRows(true);
            try {
                const res = await GetSubjectAssignments({ sid });
                setAssignments(res?.data || []);
            } catch (err) {
                setAssignments([]);
            } finally {
                setLoading(false);
                setLoadingRows(false);
            }
        };
        load();
    }, [sid]);

    const rows = useMemo(() => {

        const assignmentsArray = Array.isArray(assignments) ? assignments : [];

        return (assignmentsArray)
            .map((item) => {
               
                const student = item.studentCourses?.find(
                    (sc) => sc.intake == sid
                );

                return {
                    name: item.name,
                    type: item.ass_type,
                    isWithheld:
                        student?.gradeText?.toLowerCase() === "witheld",

                    mark:
                        student?.gradeText?.toLowerCase() === "witheld"
                            ? "WITHHELD"
                            : (item?.notify_assessed === 0
                                ? "-"
                                : (student?.grading_type == "1" ? RobotResult(student?.gradeText) : student?.gradeText ?? "-")),

                    result:
                        student?.gradeText?.toLowerCase() === "witheld"
                            ? "Withheld"
                            : (item?.notify_assessed === 0
                                ? "Pending"
                                : (student?.pass_status
                                    ? formatResult(student.pass_status)
                                    : "Pending")),

                    code: item.code ?? "-",
                };
            });
    }, [assignments, sid]);


    const summary = {
        overallGrade: gradeText ?? "-",
        overallResult: passStatus ?? "Pending",
    };

    if (loading) {
        return <SkeletonStudentHub />;
    }

    if (!rows || rows.length === 0) {
    return (
        <div style={styles.noRecords}>There are no records to show.</div>
    );
}

    return (
        <>
            <div style={styles.gradeBook}>
                {intakeLockStatus === 1 && (<div className="courseGradesFinalResultBox" style={styles.overallResultsBox} >
                    <div style={styles.infoColumn} >
                        <div style={styles.courseResult} >Course Results</div>
                        <div>Overall course performance summary</div>
                    </div>
                    <div className="courseGradesFinalResultBoxItem" style={styles.markResultColumn} >
                        <div>Final Grade</div>
                        <div style={getMarkColor(formatResult(summary.overallResult) ?? "-")}>{summary.overallGrade ?? "-"}</div>
                    </div>
                    <div className="courseGradesFinalResultBoxItem" style={styles.markResultColumn} >
                        <div>Final Outcome</div>
                        <div style={getResultStyle(formatResult(summary.overallResult) ?? "Pending")}>{summary.overallResult ?? "Pending"}</div>
                    </div>
                </div>)}
                <div style={styles.tableResultBox}>
                    <div style={styles.tableHeader}>
                        <div style={styles.assessmentCell}>
                            <span>Assessments   <i className="fal fa-angles-up-down" /></span>
                            <div></div>
                        </div>
                        <div style={styles.markResultCell}>
                            <span>Mark</span>
                        </div>
                        <div style={{
                            ...styles.markResultCell,
                            borderRight: "none",
                        }}>
                            <span>Result</span>
                        </div>
                    </div>
                    {loadingRows ? (
                        <SkeletonStudentHub />
                    ) : (
                        rows?.length > 0 &&
                        rows.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    ...styles.tableContent,
                                    ...(index === rows.length - 1 && { borderBottom: "none" }),
                                    ...(item.result === "Fail" ? styles.failRow : {}),
                                }}
                            >
                                <div style={styles.assessmentCell}>
                                    <span className="gradesTableAssesmentName" style={styles.assessmentName}>{item.name}</span>
                                    <span>
                                        <span style={styles.assesmentType}>{item.type}</span>
                                        <span style={styles.metaData}> {item.code}</span>
                                    </span>
                                </div>
                                <div style={styles.markResultCell}>
                                    <span style={item.isWithheld ? styles.witheldText : styles.assessmentMark}>{item.mark}</span>
                                </div>
                                <div style={{
                                    ...styles.markResultCell,
                                    borderRight: "none",
                                }}>
                                    <span style={getResultStyle(item.result ?? "Pending")}>
                                        {item.result ?? "Pending"}
                                    </span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </>
    );
};

export default SubjectGradebook;